import { schema } from "normalizr";
export const device = new schema.Entity("device");
export const deviceSchema = new schema.Entity("devices", {
  devices: [device]
}, {
  idAttribute: "deviceId"
});
export const followUp = new schema.Entity("followUp");
export const followUpSchema = new schema.Entity("followUps", {
  followUps: [followUp]
}, {
  idAttribute: "id"
});
export const activity = new schema.Entity("activity");
export const activitySchema = new schema.Entity("activities", {
  activities: [activity]
}, {
  idAttribute: "clientActivityId"
});
export const releaseNote = new schema.Entity("releaseNote");
export const releaseNoteSchema = new schema.Entity("releaseNotes", {
  releaseNotes: [releaseNote]
}, {
  idAttribute: "id"
});